import { render, staticRenderFns } from "./unit_mgt.vue?vue&type=template&id=06bd8ac8&scoped=true&"
import script from "./unit_mgt.vue?vue&type=script&lang=js&"
export * from "./unit_mgt.vue?vue&type=script&lang=js&"
import style0 from "./unit_mgt.vue?vue&type=style&index=0&id=06bd8ac8&scoped=true&lang=less&"
import style1 from "./unit_mgt.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bd8ac8",
  null
  
)

export default component.exports